import { CheckCircle2, AlertCircle, FileText } from 'lucide-react';

type CtConfidence = 'auto' | 'needs_review' | 'user_confirmed' | 'sponsor_defined';

interface CtBadgeProps {
  ct_codelist_ref?: string;
  ct_match_confidence?: CtConfidence;
  className?: string;
}

const CONFIDENCE_STYLES: Record<CtConfidence, { bg: string; label: (oid?: string) => string; Icon: typeof CheckCircle2 }> = {
  auto: {
    bg: 'bg-green-100 text-green-800 border-green-300',
    label: (oid) => (oid ? `CT: ${oid}` : 'CT matched'),
    Icon: CheckCircle2,
  },
  user_confirmed: {
    bg: 'bg-green-100 text-green-800 border-green-300',
    label: (oid) => (oid ? `CT: ${oid}` : 'CT confirmed'),
    Icon: CheckCircle2,
  },
  needs_review: {
    bg: 'bg-amber-100 text-amber-800 border-amber-300',
    label: () => 'Needs review',
    Icon: AlertCircle,
  },
  sponsor_defined: {
    bg: 'bg-gray-100 text-gray-700 border-gray-300',
    label: () => 'Sponsor-defined',
    Icon: FileText,
  },
};

export default function CtBadge({ ct_codelist_ref, ct_match_confidence, className }: CtBadgeProps) {
  if (!ct_match_confidence) return null;
  const style = CONFIDENCE_STYLES[ct_match_confidence];
  if (!style) return null;
  const { Icon } = style;
  const title = ct_codelist_ref
    ? `CDISC CT codelist ${ct_codelist_ref} — ${ct_match_confidence.replace('_', ' ')}`
    : `${ct_match_confidence.replace('_', ' ')}`;
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-semibold rounded border ${style.bg} ${className || ''}`}
      title={title}
    >
      <Icon className="w-3 h-3" />
      {style.label(ct_codelist_ref)}
    </span>
  );
}
